import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import * as myConstClass from '../../constant.js';
import { Button } from "reactstrap";
import * as Icon from "react-feather";
import $ from 'jquery';

class Page404 extends PureComponent {
  constructor(props) {
    super(props);
    this.routeChange = this.routeChange.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  routeChange() {
    this.props.history.push('/');
  }

  handleLogout() {
    localStorage.clear();                          // Clear all localStorage items
    this.props.history.push('/');                  // Redirect to login page
  }

  componentDidMount() {
    $('.main').css('background-image', 'none');
    $('.main').css('background-size', 'none');
  }

  render() {
    return (
      <div className="text-center">
        <p className="h2 font-weight-normal mt-3 mb-4">
          Connecting............
        </p>

        <Link to={'/' + myConstClass.TENANT_PAGE_PATH + "dashboard"}>
          <Button color="primary" size="lg" className="mr-2">
            Return to Dashboard and Refresh It by pressing <Icon.RotateCw />
          </Button>
        </Link>

        {/* Logout Button */}
        <Button
          color="danger"
          size="lg"
          onClick={this.handleLogout}
        >
          <Icon.LogOut size={18} className="mr-1" />
          Logout
        </Button>
      </div>
    )
  }
}

export default Page404;

